import React from 'react'

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import FolderIcon from '@mui/icons-material/Folder';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HomePageRes from '../Responsive/HomeBundle/HomePageRes';
import HomeIcon from '../assets/general/homeIcon.svg'
import PlaylistIcon from '../assets/general/playlistIcon.svg'
import AddEvent from '../assets/general/addEvent.svg'
import NotificationIcon from '../assets/general/notificationIcon.svg'
import ProfileIcon from '../assets/general/profileIcon.svg'
import { Link, useNavigate } from 'react-router-dom';

function Navigation() {
    const [value, setValue] = React.useState('recents')
    const navigate = useNavigate()
    const handleChange = (event, newValue) => {
      
        setValue(newValue);
        // navigate("/"+newValue)
        
    };
    const styles = {
        stickToBottom: {
          width: '100%',
          position: 'fixed',
          bottom: 0,          
        },
        selected: {
            borderBottom: "1px solid #fff",
            paddingBottom: "5px"
        }
      };
    return (
        <div>
            <BottomNavigation sx={{ width: 500, backgroundColor:"#141414", ...styles.stickToBottom }} onChange={handleChange}>
                <BottomNavigationAction
                    label="Recents"
                    value="home"
                    to="/home"
                    component={Link}
                    icon={<img src={HomeIcon} style={value == "home"? styles.selected : {}}/>}
                />
                <BottomNavigationAction
                    label="playlists"
                    value="playlists"
                    to="/playlist-page"
                    component={Link}
                    icon={<img src={PlaylistIcon} style={value == "playlists"? styles.selected : {}}/>}
                />
                <BottomNavigationAction
                    label="Create"
                    value="create"
                    to="/create-event"
                    component={Link}
                    icon={<img src={AddEvent} style={value == "create"? {paddingBottom:5} : {}}/>}
                />
                <BottomNavigationAction
                    label="Notifications"
                    value="notifications"
                    to="/notifications"
                    component={Link}
                    icon={<img src={NotificationIcon} style={value == "notifications"? styles.selected : {}}/>}
                />                
                <BottomNavigationAction 
                    label="Profile"
                    to="/profile-page"
                    value="profile"
                    component={Link}
                    icon={<img src={ProfileIcon} style={value == "profile"? styles.selected : {}}/>} />
            </BottomNavigation>
        </div>
    )
}

export default Navigation